import { render, staticRenderFns } from "./fee-calculator-panel.vue?vue&type=template&id=6858be9e&"
import script from "./fee-calculator-panel.vue?vue&type=script&lang=js&"
export * from "./fee-calculator-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports